import { render } from "./AssemblyInspectorControls.vue?vue&type=template&id=8cb0597a&scoped=true"
import script from "./AssemblyInspectorControls.vue?vue&type=script&lang=js"
export * from "./AssemblyInspectorControls.vue?vue&type=script&lang=js"

import "./AssemblyInspectorControls.vue?vue&type=style&index=0&id=8cb0597a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cb0597a"]])

export default __exports__